import React from 'react';
import { INamedFilterFieldsFragment } from '../../utils/apollo/graphqlSchema';
import BuilderInfo from '../BuilderInfo';
import VersionedEntity from './VersionedEntity';

interface INamedFilterLabel {
  namedFilter: INamedFilterFieldsFragment;
  onRemoveNamedFilter?: () => void;
  onExpandNamedFilter?: (id: string) => void;
  onClick?: () => void;
  onShowInfo?: () => void;
  backgroundColor?: string;
}

export default ({
  namedFilter,
  onRemoveNamedFilter,
  onExpandNamedFilter,
  onClick,
  onShowInfo,
  backgroundColor,
}: INamedFilterLabel) => (
  <VersionedEntity
    label={namedFilter.name}
    onClick={onClick}
    onClear={onRemoveNamedFilter}
    isDisabled={namedFilter.isDisabled}
    isLatestVersion={namedFilter.isLatestVersion}
    onShowInfo={onShowInfo}
    backgroundColor={backgroundColor}
  >
    <BuilderInfo
      kind="namedFilter"
      namedFilter={namedFilter}
      onExpand={
        typeof onExpandNamedFilter === 'function'
          ? () => onExpandNamedFilter(namedFilter.id)
          : undefined
      }
    />
  </VersionedEntity>
);
